module.exports = __webpack_public_path__ + "img/left.6dea6219.png";